import { helper } from '@ember/component/helper';

export default helper(function buildTopicUrl([groupId, topicId, user]) {
  if (user === 'staff') {
    return `/groups/${groupId}/topics/topic/${topicId}/details`;
  } else {
    return `/topic/${topicId}`;
  }
});
